import BasicChartDataset from 'models/basic-chart-dataset/basic-chart-dataset.model';

export default class BasicChartData {
  public labels: string[] = [];
  public datasets: BasicChartDataset[] = [];

  constructor(model: any = null) {
    if (model) {
      this.fill(model);
    }
  }

  private fill(model: any) {
    if (model.labels) {
      this.labels = model.labels;
    }
    if (model.datasets) {
      this.datasets = [];
      for (let i = 0; i < model.datasets.length; i++) {
        this.datasets.push(new BasicChartDataset(model.datasets[i]));
      }
    }
  }
}
